import React from 'react';
import PageLayout from '../components/PageLayout';
import Explorations from '../components/Explorations';
import usePageMeta from '../hooks/usePageMeta';

export default function ExplorePage() {
  usePageMeta(
    'Itineraries and Experiences — Ocean, Earth, Wellness & Morabeza | Hotel Respiro',
    'Itineraries and experiences from Hotel Respiro: ocean adventures, volcanic hikes in Santo Antão, wellness and cabo-verdean morabeza across São Vicente and Santo Antão islands.'
  );

  return (
    <PageLayout>
      <div data-testid="explore-page">
        <Explorations />
      </div>
    </PageLayout>
  );
}
